export enum OfferCombinationType {
    PRODUCT = "PRODUCT",
    COMPLEMENT = "COMPLEMENT",
    PRICE_TABLE = "PRICE_TABLE",
    PERIOD = "PERIOD",
    QUANTITY = "QUANTITY",
    PAYMENT_METHOD = "PAYMENT_METHOD",
    COUPON = "COUPON"
}
